<template>
  <div class="body">
    <iframe v-show="showType === 'iframe'" ref="iframe" src="" frameborder="0" id='iframe' width='100%' height='100%'></iframe>
    <!-- pptx 纯前端渲染（@vue-office/pptx，不经过第三方服务器，适配内网/非公网文件） -->
    <vue-office-pptx
      v-show="showType === 'pptx'"
      :src="pptxUrl"
      class="office-pptx"
      @error="onOfficeError"
    />
    <!-- 不支持在浏览器直接预览的类型（如 .ppt 老版二进制格式、.doc 等）兜底：提示并支持下载到本地打开 -->
    <div v-show="showType === 'fallback'" class="office-fallback">
      <i class="el-icon-document" />
      <p class="fb-msg">{{ fallbackMsg }}</p>
      <a :href="fallbackUrl" target="_blank" rel="noopener" class="fb-dl">下载文件并在本地用 PowerPoint / WPS 打开</a>
    </div>
  </div>
</template>

<script>
// 引入 pptx 纯前端渲染组件（不依赖第三方服务器，适配内网/非公网文件）
// 注意：该包未附带 css，且 main 入口缺失，Vue2 需显式引入 lib/v2 构建；组件自带内联样式，无需再引 css
import VueOfficePptx from '@vue-office/pptx/lib/v2'
export default {
  name: 'IframeFile',
  components: {VueOfficePptx},
  // 支持通过 prop 直接传入文件地址（列表场景复用），也可通过 ref.open(url) 命令式调用
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showType: '',
      docUrl: '',
      pptxUrl: '',
      fallbackUrl: '',
      fallbackMsg: ''
    }
  },
  watch: {
    src (val) {
      if (val) this.open(val)
      else this.reset()
    }
  },
  mounted () {
    if (this.src) this.open(this.src)
  },
  methods: {
    open (url) {
      if (!url) {
        this.$message && this.$message.warning('文件地址为空，无法预览')
        return
      }
      this.$nextTick(() => {
        const lower = url.toLowerCase()
        const iframe = this.$refs.iframe
        if (lower.indexOf('.pptx') > -1) {
          this.showPptx(url)
        } else if (lower.indexOf('.pdf') > -1) {
          this.showType = 'iframe'
          if (iframe) iframe.src = this.resolveAbsoluteUrl(url)
        } else if (lower.indexOf('.docx') > -1 || lower.indexOf('.doc') > -1) {
          // 纯前端无可靠的 doc 渲染库，统一走下载兜底
          this.showFallback(url, '当前浏览器无法直接预览该 Word 文档')
        } else if (lower.indexOf('.ppt') > -1) {
          // 老版 .ppt 二进制格式，浏览器端无法解析，走下载兜底
          this.showFallback(url, '老版 .ppt 格式文件无法在浏览器中直接预览')
        } else {
          this.showFallback(url, '暂不支持在浏览器中直接预览该文件类型')
        }
      })
    },
    reset () {
      this.showType = ''
      this.pptxUrl = ''
      this.docUrl = ''
      this.fallbackUrl = ''
    },
    // 展示 pptx：使用 @vue-office/pptx 纯前端渲染，文件由浏览器端直接 fetch，不经过第三方服务器
    showPptx (url) {
      this.showType = 'pptx'
      this.pptxUrl = this.resolveAbsoluteUrl(url)
    },
    // pptx 渲染失败兜底：通常为跨域(CORS)或文件损坏，提示并给出下载入口
    onOfficeError (e) {
      console.error('pptx 前端渲染失败：', e)
      this.showFallback(this.pptxUrl, 'pptx 预览渲染失败（可能是跨域限制或文件损坏）')
    },
    // 不支持类型的兜底：展示提示并提供下载
    showFallback (url, msg) {
      this.showType = 'fallback'
      this.fallbackUrl = this.resolveAbsoluteUrl(url)
      this.fallbackMsg = msg || '该文件无法在浏览器中直接预览'
    },
    // 相对路径补全为绝对地址，便于组件端 fetch 同网段文件
    resolveAbsoluteUrl (url) {
      return /^(https?:)?\/\//i.test(url) ? url : `${window.location.origin}${url}`
    }
  }
}
</script>
<style scoped>
.body {
  height: calc(100% - 100px);
}
.office-pptx {
  height: 100%;
  width: 100%;
}
.office-fallback {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  background: #f5f7fa;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  box-sizing: border-box;
}
.office-fallback .el-icon-document {
  font-size: 40px;
  margin-bottom: 12px;
}
.office-fallback .fb-msg {
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.6;
}
.office-fallback .fb-dl {
  color: #409eff;
  text-decoration: none;
  font-size: 14px;
}
.office-fallback .fb-dl:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Iframe/index.vue